import React from 'react';

const Remove = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="10"
    height="10"
    viewBox="0 0 14 14"
  >
    <path d="M7.327 5.998l4.398-4.397A.938.938 0 1010.398.275L6 4.672 1.602.275A.938.938 0 00.275 1.6l4.398 4.397-4.398 4.397a.938.938 0 000 1.327.94.94 0 00.657.278.89.89 0 00.657-.278L6 7.325l4.398 4.397a.94.94 0 00.657.278.89.89 0 00.657-.278.938.938 0 000-1.327L7.327 5.998z" />
  </svg>
);

export default Remove;
